import { API_URL } from "../../../utils/config";

export const GET_FEATURE_REQUESTS_URL = `${API_URL}/feature-requests/requests`;
export const UPDATE_FEATURE_REQUEST_URL = `${API_URL}/feature-requests/updateStatus`;
export const GET_FEATURE_REQUESTS_BY_DEPARTMENTS_URL = `${API_URL}/feature-requests/getByDepartment`;
export const ADD_FEATURE_REQUEST_URL = `${API_URL}/feature-requests`;